import { all, call, put, takeEvery } from 'redux-saga/effects'
import AssetManagementApiService from './AssetManagementApiService'
import { GET_ASSET_TYPE, GET_NON_REQUISITION_ASSET_TYPE } from '../../Store/AssetManagement/AssetType/AssetTypeType'
import { setAssetType, setNonRequisitionAssetType } from 'Store/AssetManagement/AssetType/AssetTypeAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setIsDropDownsLoading } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';

function* getAssetTypes(_req: any): any {
    yield put(setIsDropDownsLoading(true))
let payloadData : IPayload= {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/assettypes?isBulkOrder=${_req?.isBulkOrder}`,
        payload : null
    }
    try {
        

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if(!_req?.isBulkOrder){
            const defaultAssetTypeOption = {
                orderRequestType: `Select Requisition Type`,
            };
            response.unshift(defaultAssetTypeOption);
        }
        yield put(setAssetType(response))

        yield put(setIsDropDownsLoading(false))

    } catch (error) {
        yield put(setAssetType([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* getNonRequisitionAssetTypes(_req: any): any {
    yield put(setIsDropDownsLoading(true))
    let payloadData : IPayload= {
        apiType : apiType.AssetManagement,
        endpoint : `assets/dropdown/assettypes/nonrequisition`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    
    try {
        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );

        yield put(setNonRequisitionAssetType(response))

        yield put(setIsDropDownsLoading(false))

    } catch (error) {
        yield put(setNonRequisitionAssetType([]))
        yield put(setIsDropDownsLoading(false))
    }
}

function* watchGetAssetTypes() {
    yield takeEvery(GET_ASSET_TYPE, getAssetTypes)
    yield takeEvery(GET_NON_REQUISITION_ASSET_TYPE, getNonRequisitionAssetTypes)
}

export default function* combinedSaga() {
    yield all([
        watchGetAssetTypes()
    ])
}
